import { SET_UPCOMING_LEAVES } from "../../../../enums/Common/Common";

export const setUpcomingLeavesAction = (data) => ({
    type: SET_UPCOMING_LEAVES,
    payload: data,
});